import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ImportarArquivoRequest } from '../../requests/financas/importar-arquivo.request';
import { ValidacaoImportacaoCategoriaFinanceiraResponse } from '../../responses/financas/validacao-importacao-categoria-financeira.response';
import { ItemValidacaoCategoriaFinanceiraStruct } from '../../structs/financas/item-validacao-categoria-financeira.struct';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class ImportarCategoriaFinanceiraService extends CommonService {
  private readonly apiUrl = `${environment.urlApiFinancas}ImportarCategoriaFinanceira`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public validar(request: ImportarArquivoRequest): Observable<ValidacaoImportacaoCategoriaFinanceiraResponse> {
    const url = `${this.apiUrl}/validar`;

    return this.httpClient
      .post<ValidacaoImportacaoCategoriaFinanceiraResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confirmar(itens: ItemValidacaoCategoriaFinanceiraStruct[]): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/confirmar`;

    return this.httpClient
      .post<ReturnStruct>(url, itens, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
